<template>
  <v-dialog v-model="dialog" max-width="1200" >
    <v-card :disabled="loading">
      <v-toolbar dark color="red darken-2">
        <v-toolbar-title>{{ papel }}</v-toolbar-title>
      </v-toolbar>
      <v-card-tex>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="parentMenu in items"
            :key="parentMenu.nome"
          >
            <v-expansion-panel-header>{{ parentMenu.nome }}</v-expansion-panel-header>
            <v-expansion-panel-content>
                <div
                  v-for="acesso in parentMenu.acessos"
                  :key="parentMenu.nome+acesso.nome"
                  style="margin-top: -25px"
                >
                  <v-checkbox
                    v-model="acesso.isAcesso"
                    :label="acesso.nome"
                    class="mr-2"
                  />
                </div>
                <div v-if="parentMenu.children">
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="children in parentMenu.children"
                      :key="children.nome"
                    >
                      <v-expansion-panel-header>{{ children.nome }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div
                            v-for="acesso in children.acessos"
                            :key="children.nome+acesso.nome"
                            style="margin-top: -25px"
                          >
                            <v-checkbox
                              v-model="acesso.isAcesso"
                              :label="acesso.nome"
                              class="mr-2"
                            />
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-tex>
      <v-divider class="mt-5"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-2"
          class="mr-1"
          dark
          outlined
          rounded
          small
          :loading="loading"
          @click="salvar()"
        >
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn>
        <v-btn color="red darken-2" dark outlined rounded small @click="dialog = false">
          <v-icon>mdi-close</v-icon>
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Menus from '@/services/menus'
import Papeis from '@/services/papeis'

export default {
  name: 'DialogDefineAcessos',

  data() {
    return {
      dialog: false,
      loading: false,
      papel: '',

      items: []
    }
  },

  methods: {
    async getAcessos()
    {
      try
      {
        this.loading = true
        let acessos = await new Papeis().getAcessos(this.papel)
        let menus = await new Menus().list()
        menus = this.formatMenus(menus)
        if(acessos && menus)
        {
          for(let currentAcesso of acessos)
          {
            for(let currentMenu of menus)
            {
              if(currentMenu.nome == currentAcesso.nome)
              {
                for(let currentAcessoA of currentAcesso.acessos)
                {
                  for(let currentMenuA of currentMenu.acessos)
                  {
                    if(currentMenuA.nome == currentAcessoA.nome)
                    {
                      currentMenuA.isAcesso = currentAcessoA.isAcesso
                    }
                  }
                }
                if(currentMenu.children && currentAcesso.children)
                {
                  for(let currentAcessoChild of currentAcesso.children)
                  {
                    for(let currentMenuChild of currentMenu.children)
                    {
                      if(currentMenuChild.nome == currentAcessoChild.nome)
                      {
                        for(let currentAcessoChildA of currentAcessoChild.acessos)
                        {
                          for(let currentMenuChildA of currentMenuChild.acessos)
                          {
                            if(currentMenuChildA.nome == currentAcessoChildA.nome)
                            {
                              currentMenuChildA.isAcesso = currentAcessoChildA.isAcesso
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          this.items = menus
        }
        else if(acessos)
        {
          this.items = acessos
        }
        else
        {
          this.items = menus
        }
      }
      catch(error)
      {
        console.error(error)
        this.$swal.error(error)
      }
      finally
      {
        this.loading = false
      }
    },

    async salvar() {
      try
      {
        this.loading = true
        await new Papeis().updateAcessos(this.papel, this.items)
        this.$swal.success('', 'Acessos atualizados com sucesso!')
      }
      catch(error)
      {
        console.error(error)
        this.$swal.error(error)
      }
      finally
      {
        this.loading = false
      }
    },

    formatMenus(menus) {
      for(let currentMenu of menus)
      {
        for(let currentAcesso of currentMenu.acessos)
        {
          currentAcesso.isAcesso = false
        }

        if(currentMenu.children)
        {
          for(let currentChildren of currentMenu.children)
          {
            for(let currentAcessoChild of currentChildren.acessos)
            {
              currentAcessoChild.isAcesso = false
            }
          }
        }
      }

      return menus
    },

    show(show, papel) {
      this.dialog = show
      this.papel = papel
      this.getAcessos()
    }
  }
}
</script>
